// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterItem_wrapper__QeYOY","active":"FilterItem_active__+QZqa"};